import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { FONT_SIZE_BUTTON } from "../../utils/constants";

const FilterSelect = ({
  value,
  onChange,
  options = [],
  minWidth = 160,
  size = "small",
  placeholder = "",
  icon = null,
  sx = {},
  ...otherProps
}) => {
  return (
    <Box sx={{ display: "flex", gap: 0.2, flexDirection: "column" }}>
      <FormControl size={size} sx={{ minWidth, ...sx }}>
        <Select
          value={value}
          onChange={onChange}
          displayEmpty={!!placeholder}
          startAdornment={
            icon && <InputAdornment position="start">{icon}</InputAdornment>
          }
          sx={{
            fontSize: FONT_SIZE_BUTTON,
            fontWeight: 600,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              fontSize: FONT_SIZE_BUTTON,
              fontWeight: 600,
            },
          }}
          {...otherProps}
        >
          {placeholder && (
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
          )}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FilterSelect;
